import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

interface HandleTooltipProps {
  handleType: 'CCS1' | 'CCS2' | 'AC' | 'INLET';
  power: number | null;
  voltage: number | null;
  current: number | null;
  connected?: boolean;
}

const HandleTooltip: React.FC<HandleTooltipProps> = ({
  handleType,
  power,
  voltage,
  current,
  connected = false
}) => {
  const theme = useTheme();

  const formatValue = (value: number | null, unit: string): string => {
    if (value === null || value === undefined) {
      return '  – ';
    }
    return `${value} ${unit}`;
  };

  return (
    <Box sx={{
      backgroundColor: 'white',
      color: theme.palette.text.primary,
      padding: '8px 12px',
      borderRadius: '6px',
      fontSize: '12px',
      fontFamily: 'Montserrat',
      width: '160px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
      zIndex: 1000,
    }}>
      <Typography variant="subtitle2" sx={{ 
        fontWeight: 600, 
        marginBottom: '4px',
        color: (handleType === 'AC' || handleType === 'INLET') ? theme.palette.text.primary : (connected ? theme.palette.success.main : theme.palette.extra.neutrals.grey),
        fontSize: '11px'
      }}>
        {handleType === 'AC' ? 'AC Outlet' : handleType === 'INLET' ? 'Grid Input' : `${handleType} ${connected ? 'Connected' : 'Disconnected'}`}
      </Typography>
      
      <Box sx={{ display: 'flex', flexDirection: 'column'}}>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <Typography variant="body2" sx={{ fontSize: '10px', color: theme.palette.text.primary }}>
          Power:
        </Typography>
        <Typography variant="body2" sx={{ fontSize: '10px', color: theme.palette.text.primary }}>
          {formatValue(power, 'kW')}
        </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <Typography variant="body2" sx={{ fontSize: '10px', color: theme.palette.text.primary} }>
          Voltage:
        </Typography>
        <Typography variant="body2" sx={{ fontSize: '10px', color: theme.palette.text.primary} }>
          {formatValue(voltage, 'V')}
        </Typography>
        </Box>
        {/* Only show current for CCS1 and CCS2, not for AC or INLET */}
        {(handleType === 'CCS1' || handleType === 'CCS2') && (
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <Typography variant="body2" sx={{ fontSize: '10px', color: theme.palette.text.primary }}>
            Current:
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '10px', color: theme.palette.text.primary }}>
            {formatValue(current, 'A')}
          </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default HandleTooltip;
